    export const region = [
        {
            "label": "Алтайский край",
            "value": 34688
        },
        {
            "label": "Амурская область",
            "value": 277
        },
        {
            "label": "Архангельская область",
            "value": 49102
        },
        {
            "label": "Астраханская область",
            "value": 27420
        },
        {
            "label": "Белгородская область",
            "value": 4105
        },
        {
            "label": "Брянская область",
            "value": 42
        },
        {
            "label": "Владимирская область",
            "value": 4106
        },
        {
            "label": "Волгоградская область",
            "value": 27667
        },
        {
            "label": "Вологодская область",
            "value": 170
        },
        {
            "label": "Воронежская область",
            "value": 27
        },
        {
            "label": "ДНР",
            "value": 124113
        },
        {
            "label": "Еврейская автономная область",
            "value": 4109
        },
        {
            "label": "Забайкальский край",
            "value": 147
        },
        {
            "label": "Запорожская область",
            "value": 124287
        },
        {
            "label": "Ивановская область",
            "value": 26331
        },
        {
            "label": "Иркутская область",
            "value": 207
        },
        {
            "label": "Кабардино-Балкарская Республика",
            "value": 196
        },
        {
            "label": "Калининградская область",
            "value": 27077
        },
        {
            "label": "Калужская область",
            "value": 32534
        },
        {
            "label": "Камчатский край",
            "value": 4112
        },
        {
            "label": "Карачаево-Черкесская Республика",
            "value": 304
        },
        {
            "label": "Кемеровская область",
            "value": 4113
        },
        {
            "label": "Кировская область",
            "value": 81
        },
        {
            "label": "Костромская область",
            "value": 45
        },
        {
            "label": "Краснодарский край",
            "value": 296
        },
        {
            "label": "Красноярский край",
            "value": 121595
        },
        {
            "label": "Курганская область",
            "value": 4115
        },
        {
            "label": "Курская область",
            "value": 57095
        },
        {
            "label": "Ленинградская область",
            "value": 25
        },
        {
            "label": "Липецкая область",
            "value": 178
        },
        {
            "label": "Магаданская область",
            "value": 4116
        },
        {
            "label": "Москва",
            "value": 4107
        },
        {
            "label": "Московская область",
            "value": 39184
        },
        {
            "label": "Мурманская область",
            "value": 31746
        },
        {
            "label": "Ненецкий автономный округ",
            "value": 205
        },
        {
            "label": "Нижегородская область",
            "value": 280
        },
        {
            "label": "Новгородская область",
            "value": 287
        },
        {
            "label": "Новосибирская область",
            "value": 33595
        },
        {
            "label": "Омская область",
            "value": 127
        },
        {
            "label": "Оренбургская область",
            "value": 2464
        },
        {
            "label": "Орловская область",
            "value": 181
        },
        {
            "label": "Пензенская область",
            "value": 4118
        },
        {
            "label": "Пермский край",
            "value": 124
        },
        {
            "label": "Приморский край",
            "value": 254
        },
        {
            "label": "Псковская область",
            "value": 35731
        },
        {
            "label": "Республика Адыгея",
            "value": 4120
        },
        {
            "label": "Республика Алтай",
            "value": 4121
        },
        {
            "label": "Республика Башкортостан",
            "value": 49591
        },
        {
            "label": "Республика Бурятия",
            "value": 113
        },
        {
            "label": "Республика Дагестан",
            "value": 214
        },
        {
            "label": "Республика Ингушетия",
            "value": 31140
        },
        {
            "label": "Республика Калмыкия",
            "value": 108
        },
        {
            "label": "Республика Карелия",
            "value": 85
        },
        {
            "label": "Республика Коми",
            "value": 4122
        },
        {
            "label": "Республика Крым",
            "value": 4123
        },
        {
            "label": "Республика Марий Эл",
            "value": 91
        },
        {
            "label": "Республика Мордовия",
            "value": 4124
        },
        {
            "label": "Республика Саха",
            "value": 266
        },
        {
            "label": "Республика Северная Осетия - Алания",
            "value": 4125
        },
        {
            "label": "Республика Татарстан",
            "value": 23
        },
        {
            "label": "Республика Тыва",
            "value": 4126
        },
        {
            "label": "Республика Хакасия",
            "value": 4127
        },
        {
            "label": "Ростовская область",
            "value": 24816
        },
        {
            "label": "Рязанская область",
            "value": 29339
        },
        {
            "label": "Самарская область",
            "value": 1312
        },
        {
            "label": "Санкт-Петербург",
            "value": 36
        },
        {
            "label": "Саратовская область",
            "value": 4129
        },
        {
            "label": "Сахалинская область",
            "value": 29195
        },
        {
            "label": "Свердловская область",
            "value": 28356
        },
        {
            "label": "Севастополь",
            "value": 4108
        },
        {
            "label": "Смоленская область",
            "value": 30437
        },
        {
            "label": "Ставропольский край",
            "value": 1348
        },
        {
            "label": "Тамбовская область",
            "value": 31420
        },
        {
            "label": "Тверская область",
            "value": 29989
        },
        {
            "label": "Томская область",
            "value": 31930
        },
        {
            "label": "Тульская область",
            "value": 452
        },
        {
            "label": "Тюменская область",
            "value": 29622
        },
        {
            "label": "Удмуртская республика",
            "value": 47503
        },
        {
            "label": "Ульяновская область",
            "value": 93
        },
        {
            "label": "Хабаровский край",
            "value": 164
        },
        {
            "label": "Ханты-Мансийский автономный округ - Югра",
            "value": 3348
        },
        {
            "label": "Челябинская область",
            "value": 48307
        },
        {
            "label": "Чеченская республика",
            "value": 4133
        },
        {
            "label": "Чувашская Республика",
            "value": 1532
        },
        {
            "label": "Чукотский автономный округ",
            "value": 270
        },
        {
            "label": "Ямало-Ненецкий автономный округ",
            "value": 36842
        },
        {
            "label": "Ярославская область",
            "value": 35972
        }
    ];

   